import React,{ useEffect, useState } from "react"
import {
  FaTimesCircle as XCircle,
  FaRedo as RefreshCw,
  FaHome as Home,
  FaEnvelope as Mail,
  FaPhone as Phone,
  FaExclamationTriangle as AlertTriangle,
  FaCreditCard as CreditCard,
  FaUniversity as Building,
  FaWallet as Wallet,
  FaQuestionCircle as HelpCircle,
  FaShieldAlt as Shield,
  FaDollarSign as DollarSign,
  FaSyncAlt as Sync,
} from "react-icons/fa"
import "./success-failure.css"

export default function FailurePage() {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("upi")

  const failureData = {
    orderId: "AMASI2025-789123",
    amount: 10880,
    errorCode: "PAYMENT_FAILED",
    errorMessage: "Transaction was declined by your bank",
    timestamp: "2025-01-08T14:30:00Z",
    attemptedPaymentMethod: "UPI",
    registrantName: "Dr. Rajesh Kumar",
    email: "rajesh.kumar@email.com",
    ticketDetails: [
      {
        name: "PGs, NBE, Fellow, MCh Students",
        quantity: 1,
        price: 8000,
      },
    ],
  }

  const paymentMethods = [
    { id: "upi", name: "UPI", icon: Wallet },
    { id: "card", name: "Credit/Debit Card", icon: CreditCard },
    { id: "netbanking", name: "Net Banking", icon: Building },
  ]

  const commonIssues = [
    {
      issue: "Insufficient Balance",
      solution: "Please check your account balance and try again",
    },
    {
      issue: "Network Timeout",
      solution: "Check your internet connection and retry the payment",
    },
    {
      issue: "Bank Server Issues",
      solution: "Try using a different payment method or contact your bank",
    },
    {
      issue: "Card Expired",
      solution: "Please use a valid card or try another payment method",
    },
  ]

  return (
    <section className="success_failer_common">
    <div className="failure-container">
      {/* Background with same elements as main page */}
      <div className="failure-background">
        <div className="bg-decorations">
          <div className="decoration-circle-1"></div>
          <div className="decoration-circle-2"></div>
          <div className="decoration-circle-3"></div>
          <div className="floating-shape-1"></div>
          <div className="floating-shape-2"></div>
          <div className="floating-shape-3"></div>
          <div className="triangle-1"></div>
          <div className="triangle-2"></div>
          <div className="diamond-1"></div>
          <div className="diamond-2"></div>
          <div className="particle-1"></div>
          <div className="particle-2"></div>
          <div className="particle-3"></div>
          <div className="particle-4"></div>
          <div className="particle-5"></div>
          <div className="gradient-orb-1"></div>
          <div className="gradient-orb-2"></div>
          <div className="gradient-orb-3"></div>
          <div className="polygon-1"></div>
          <div className="polygon-2"></div>
          <div className="spiral-1"></div>
          <div className="spiral-2"></div>
          <div className="plus-1"></div>
          <div className="plus-2"></div>
        </div>

        {/* Diagonal stripe pattern */}
        <div className="stripe-pattern failure-stripes"></div>
      </div>

      {/* Failure Content */}
      <div className="failure-content">
        <div className="failure-card">
          {/* Header */}
          <div className="failure-header">
            <div className="event-header">
              <h1 className="event-title">AMASICON 2025</h1>
              <p className="event-subtitle">28 Aug - 31 Aug, 2025 | Rajasthan</p>
            </div>
          </div>

          {/* Failure Message */}
          <div className="failure-message">
            <div className="failure-icon">
              <XCircle />
            </div>
            <h2 className="failure-title">Payment Failed</h2>
            <p className="failure-subtitle">
              Don't worry! Your registration attempt was unsuccessful, but no amount has been deducted from your
              account. You can retry the payment using the same or different payment method.
            </p>
            <div className="failure-badges">
              <span className="failure-badge">
                <Shield className="badge-icon" />
                Secure Transaction
              </span>
              <span className="failure-badge">
                <DollarSign className="badge-icon" />
                No Deduction
              </span>
              <span className="failure-badge">
                <Sync className="badge-icon" />
                Retry Available
              </span>
            </div>
          </div>

          {/* Error Details */}
          <div className="details-section">
            <h3 className="section-title">
              <AlertTriangle className="section-icon" />
              Transaction Details
            </h3>
            <div className="error-details">
              <div className="error-item">
                <span className="error-label">Order ID:</span>
                <span className="error-value">{failureData.orderId}</span>
              </div>
              <div className="error-item">
                <span className="error-label">Amount:</span>
                <span className="error-value">₹{failureData.amount.toLocaleString()}</span>
              </div>
              <div className="error-item">
                <span className="error-label">Payment Method:</span>
                <span className="error-value">{failureData.attemptedPaymentMethod}</span>
              </div>
              <div className="error-item">
                <span className="error-label">Error:</span>
                <span className="error-value error-message">{failureData.errorMessage}</span>
              </div>
              <div className="error-item">
                <span className="error-label">Time:</span>
                <span className="error-value">{new Date(failureData.timestamp).toLocaleString()}</span>
              </div>
            </div>
          </div>

          {/* Ticket Summary */}
          <div className="details-section">
            <h3 className="section-title">Your Selected Tickets</h3>
            <div className="ticket-summary">
              {failureData.ticketDetails.map((ticket, index) => (
                <div key={index} className="ticket-item">
                  <div className="ticket-info">
                    <span className="ticket-name">{ticket.name}</span>
                    <span className="ticket-quantity">Qty: {ticket.quantity}</span>
                  </div>
                  <span className="ticket-price">₹{ticket.price.toLocaleString()}</span>
                </div>
              ))}
            </div>
            <div className="ticket-note">
              <p>Your ticket selection has been saved. You can retry payment to complete your registration.</p>
            </div>
          </div>

          {/* Retry Payment */}
          <div className="details-section">
            <h3 className="section-title">Try Again</h3>
            <p className="retry-description">Choose a different payment method or retry with the same method</p>

            <div className="payment-methods">
              {paymentMethods.map((method) => {
                const IconComponent = method.icon
                return (
                  <button
                    key={method.id}
                    className={`payment-method ${selectedPaymentMethod === method.id ? "selected" : ""}`}
                    onClick={() => setSelectedPaymentMethod(method.id)}
                  >
                    <IconComponent className="payment-icon" />
                    <span>{method.name}</span>
                  </button>
                )
              })}
            </div>

            <button className="btn btn-primary btn-large retry-btn">
              <RefreshCw className="btn-icon" />
              Retry Payment - ₹{failureData.amount.toLocaleString()}
            </button>
          </div>

          {/* Common Issues */}
          <div className="details-section">
            <h3 className="section-title">
              <HelpCircle className="section-icon" />
              Common Issues & Solutions
            </h3>
            <div className="issues-list">
              {commonIssues.map((item, index) => (
                <div key={index} className="issue-item">
                  <div className="issue-title">{item.issue}</div>
                  <div className="issue-solution">{item.solution}</div>
                </div>
              ))}
            </div>
          </div>

          

          {/* Back to Home */}
          <div className="back-home">
            <button className="btn btn-outline btn-large">
              <Home className="btn-icon" />
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
    </section>
  )
}
